let usage = `
<AppHeader>
  <template #left>
    <Button icon="menu" plain />
  </template>
  Hello, World!
  <template #right>
    <Button icon="account_circle" plain />
  </template>
</AppHeader>
`.slice(1);

export default {
  usage
};
